import Hammer from 'hammerjs'

(function ($) {
  function hammerify(el, options) {
    var $el = $(el);
    if (!$el.data('hammer')) {
      var hammer = new Hammer($el[0], options);
      hammer.get('pinch').set({ enable: true });
      $el.data('hammer', hammer);
    }
  }

  $.fn.hammer = function (options) {
    return this.each(function () {
      hammerify(this, options);
    });
  };

  // extend the emit method to also trigger jQuery events
  Hammer.Manager.prototype.emit = (function (originalEmit) {
    return function (type, data) {
      originalEmit.call(this, type, data);
      $(this.element).trigger({
        type: type,
        gesture: data,
      });
    };
  })(Hammer.Manager.prototype.emit);
})($);
